export default __webpack_public_path__ + "static/media/info.3a8b83bd.svg";